const normalize = value => {
	if (Array.isArray(value)) return value.map(normalize);
	if (value && typeof value === 'object') {
		return Object.keys(value).sort().reduce((result, key) => ({
			...result,
			[key]: normalize(value[key]),
		}), {});
	}
	return value ?? null;
};

export const getListenerCriteriaSignature = criteria => JSON.stringify(normalize({
	filters: criteria?.filters || [],
	limit: criteria?.limit ?? false,
	pageIndex: Number(criteria?.limit) > 0 ? criteria?.pageIndex || 0 : null,
	sortFields: criteria?.sortFields || [],
}));

export const getChangedListenerAliases = (aliases, previous = {}, next = {}) =>
	aliases.filter(alias => previous[alias] !== next[alias]);
